<script setup lang="ts">
import { useOnOpenModal } from "vacv-common";
import { onMounted } from "vue";
import { VueFinalModal } from "vue-final-modal";
interface Props {
  url: string;
}
defineProps<Props>();
const emit = defineEmits<(event: "close") => void>();

onMounted(() => {
  const hybrisModal = document.querySelector(
    "#y_sessionExpirationPreWarningModal"
  );
  if (hybrisModal) {
    useOnOpenModal(hybrisModal as HTMLElement, () => emit("close"));
  }
});
</script>
<template>
  <vue-final-modal
    name="iframemodal"
    classes="modal-container"
    content-class="modal-content"
  >
    <button
      class="modal-close btn-close"
      @click="
        (e) => {
          e.preventDefault();
          emit('close');
        }
      "
      :aria-label="$t('common.buttons.close')"
    ></button>
    <iframe class="modal-iframe" title="hotel details" :src="url"></iframe>
  </vue-final-modal>
</template>

<style lang="scss">
@use "vacv-components/themes/acv-default/default-includes" as *;

.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container h4 {
  margin: 0;
  padding-left: 20px;
  color: $col-black;
}

.modal-content {
  position: relative;
  max-width: 700px;
  height: 80%;
  max-height: 800px;
  margin: auto;
  margin-top: 20px;
  padding: 20px 0;
  background-color: $col-white;
  border-radius: $border-radius;
  overflow: hidden;
}

iframe.modal-iframe {
  width: 100%;
  height: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
}

.modals-container {
  z-index: 99999999;
  position: fixed;
  top: 0;
  left: 0;
}
</style>
